import { fetchFareCalendar } from '@/apis/flight'
import moment from 'moment'

/**
 * @param {code} departure 出发地三字码
 * @param {code} arrival 目的地三字码
 * @param {moment} date 出发日期月第一天
 */
export default function (departure, arrival, date) {
  const [ begin, end ] = getRangeDate(date, 'YYYY-MM-DD')

  return new Promise((resolve, reject) => {
    const params = {
      'depCode': departure,
      'arrCode': arrival,
      'dateStart': begin,
      'dateEnd': end,
      'airlineCode': window.__MICRO_ROOT__?.airline
    }
    fetchFareCalendar(params).then(data => {
      const priceList = data.map((item) => {
        return {
          price: item.price,
          date: item.date
        }
      })

      resolve(priceList)
    }).catch(err => {
      reject(new Error(err.message))
    })
  })
}

function getRangeDate (date, format) {
  const oneDay = 24 * 3600 * 1000
  const begin = moment(date).format(format)
  const end = new Date(begin)
  end.setUTCDate(1)
  end.setMonth(end.getMonth() + 2)

  return [ begin, moment(end - oneDay).format(format) ]
}
